// removed by extract-text-webpack-plugin
module.exports = {"container":"_3E7IYvjJ8UBCJQ42COBzk0","grid":"_2_oCOxU8XhisPD9SZUqXsi","headline":"_2BgehdgvaVrOw3AuaF6oRf","list":"_3v39sYZZiffTB1fb3blRLQ","listItem":"_2adS8ic8nDhLBuu2O-mr0i"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ListBlock/styles.css
// module id = 323
// module chunks = 0